import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Auto-scrolls the window to top whenever the pathname changes.
 * Keeps the current scroll for pure query-string changes (e.g. filter panels).
 */
export default function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, [pathname]);
  return null;
}
